import React, { useState, useEffect } from 'react'

interface CheckboxOption {
  value: number
  label: string
  score: number
  text: string
  imageUrl?: string
}

interface OneOrMoreQuestionPageProps {
  options: CheckboxOption[]
  contentId: string
  multiChoice?: boolean
  answers: { [key: string]: number | number[] }
  onChange?: (questionId: string, value: number[]) => void
}

const OneOrMoreQuestionPage: React.FC<OneOrMoreQuestionPageProps> = ({
  options,
  contentId,
  multiChoice = true,
  answers,
  onChange,
}) => {
  const [selectedValues, setSelectedValues] = useState<number[]>(
    Array.isArray(answers[contentId]) ? (answers[contentId] as number[]) : [],
  )

  const handleChange = (index: number) => {
    let newSelectedValues: number[]

    if (multiChoice) {
      newSelectedValues = selectedValues.includes(index)
        ? selectedValues.filter((v) => v !== index) // Deselect
        : [...selectedValues, index] // Select
    } else {
      newSelectedValues = selectedValues.includes(index) ? [] : [index]
    }

    setSelectedValues(newSelectedValues)

    if (onChange) {
      onChange(contentId, newSelectedValues)
    }
  }

  useEffect(() => {
    const savedValues = Array.isArray(answers[contentId]) ? (answers[contentId] as number[]) : []
    const validValues = multiChoice ? savedValues : savedValues.slice(0, 1)
    setSelectedValues(validValues)
  }, [contentId, answers[contentId], multiChoice])

  return (
    <div className="checkbox-group row">
      {options.map((option, index) => {
        const inputId = `${contentId}-option-${index}`
        return (
          <div className="checkbox-group__option col-6" key={index}>
            <input
              type="checkbox"
              className="checkbox-group__input hidden-checkbox"
              id={inputId}
              checked={selectedValues.includes(index)}
              onChange={() => handleChange(index)}
            />
            <label
              htmlFor={inputId}
              className={`checkbox-group__label ${selectedValues.includes(index) ? 'checkbox-group__label--checked' : ''}`}
            >
              <img src={option.imageUrl} alt={option.text || `Option ${index + 1}`} />
              {selectedValues.includes(index) && (
                <div className="checkbox-group__overlay image-overlay">
                  <span className="fa fa-check" aria-label="bockikon"></span>
                </div>
              )}
            </label>
          </div>
        )
      })}
    </div>
  )
}

export default OneOrMoreQuestionPage
